import catalog from '@/i18n/generated/sweep-ui-locales.json';
import { normalizeLocale, type SupportedLocale } from '@/i18n/config';

export type SweepUiCopy = (typeof catalog)['en'];

export function getSweepUiCopy(locale: string | null | undefined): SweepUiCopy {
  return catalog[normalizeLocale(locale) as SupportedLocale];
}

export function formatSweepUiCopy(
  template: string,
  values: Record<string, string | number>
) {
  return Object.entries(values).reduce(
    (message, [key, value]) => message.replaceAll(`{${key}}`, String(value)),
    template
  );
}
